import $ from 'jquery'
import constants from 'scoreboard/components/constants'
import _ from 'lodash'

/**
 * The resize-dialog-content helps trees and panels to better fit within dialogs
 * vertically. In order to avoid double scrollbars, the resizer changes the
 * height of the tree so that it fits. If the height gets down to below
 * minHeight, then scrollbars will occur to preserve the usability of the tree.
 *
 * Example:
 * resizeDialogContent({
 *   dialog: this.el,
 *   maxHeight: 1000px,
 *   target: this.$('.object-selector'),
 *   minHeight: 200px
 * })
 */

/**
 * Resize a given target based on the dialog's size and a maxHeight
 * @param {HTMLElement} dialog The dialog which contains the target
 * @param {Number} maxHeight The maximum height the target should take up
 * @param {HTMLElement} target The target which is to be resized
 * @param {Number} [minHeight] The minHeight the target should take up. Defaults to 208 which provides
 * enough space for 3 tree nodes to display.
 * @param {HTMLElement} [container] If the target is in a container, we need to
 * prevent the container from adding more to the height calculations
 * @param {Boolean} [setMaxHeight] Set true if the calculated value should set
 * the `max-height` rather than the `height`
 */

function resizeDialogContent({ dialog, maxHeight, target,
		minHeight = 208, container, setMaxHeight }) {
	dialog = $(dialog)
	maxHeight = maxHeight - dialog.find('.dialog-header').height() - dialog.find('.dialog-footer').height()
	target = $(target)

	let excessHeight = 0
	dialog.find('.dialog-body-content >:not(.is-not-displayed)').each((i, el) => {
		if ($.contains(el, target) || el === container) {
			return
		}

		excessHeight += $(el).outerHeight(true)
	})

	// Reset for new calculations
	target.css({
		'height': '',
		'max-height': ''
	})
	let height
	if (_.isNil(container)) {
		height = dialog.find('.dialog-body').height() - excessHeight
		height = Math.max(height, Math.min(maxHeight, constants.OBJECT_SELECTOR_HEIGHT))
	} else {
		height = maxHeight - excessHeight
	}

	height = Math.max(minHeight, height - constants.STANDARD_MARGIN - 2) // - 2px borders

	if (setMaxHeight) {
		target.css('max-height', height)
	} else {
		target.height(height)
	}
}

export default resizeDialogContent

resizeDialogContent.__filename__ = 'components/resize-dialog-content.js'
